import React from "react";
import { Link } from "react-router-dom";
import Logo from "../Assets/LogoBG.png";

function MainFooter() {
  return (
    <div className="container  text-white ">
      <footer className="mt-5">
        <div className="row mainFooterContainer">
          <div className="col-6 col-md-2  text-start">
            <h5 className="text-warning linkHead">Links</h5>
            <hr style={{ color: "#FFC107" }} />
            <ul className="nav  footerList">
              <li className="nav-item mb-2">
                <Link to="/" className="text-decoration-none p-0 text-white aboutLinks ">
                  Home
                </Link>
              </li>
              <li className="nav-item mb-2">
                <Link to="/about" className="text-decoration-none p-0 text-white">
                  About
                </Link>
              </li>
              <li className="nav-item mb-2">
                <Link href="/cars" className="text-decoration-none p-0 text-white">
                  Cars
                </Link>
              </li>
              <li className="nav-item mb-2">
                <a
                  href="https://maps.app.goo.gl/ZNHZwW21KjHrrNteA"
                  target="_blank"
                  className="text-decoration-none p-0 text-white"
                >
                  Location
                </a>
              </li>
            </ul>
          </div>

          <div className="col-6 col-md-2 mb-3 text-start text-warning">
            <h5>Connect Us:-</h5>
            <hr style={{ color: "#FFC107" }} />
            <ul className="nav flex-column " style={{gap:"1rem"}}>
              <li className="nav-item">
                <a href="tel:+919824345377" className=" text-decoration-none  p-0 text-white">
                  +91 9824345377
                </a>
              </li>
              <li className="nav-item">
                <a href="tel:+9196872 85365" className=" text-decoration-none p-0 text-white">
                  +91 96872 85365
                </a>
              </li>
              <li className="nav-item">
                <a href="tel:+9179902 01423" className="  text-decoration-none p-0 text-white">
                  +91 79902 01423
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="mailto:Vishalglass01@gmail.com"
                  className=" p-0 text-white text-decoration-none"
                >
                  Vishalglass01@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div className="col-6 col-md-2 mb-3 text-start">
            <h5 className="text-warning">Work</h5>
            <hr style={{ color: "#FFC107" }} />
            <ul className="nav flex-column " style={{width:"12rem", gap:"0.8rem"}}>
              <li className="nav-item mb-2 ">Car Glass Replacement</li>
              <li className="nav-item mb-2">Windshield Replacement</li>
              <li className="nav-item mb-2">Side Glass</li>
              <li className="nav-item mb-2">Rear Door Glass</li>
              <li className="nav-item mb-2">Fort door glass</li>
              <li className="nav-item mb-2">QTR glass (R/F)</li>
              <li className="nav-item mb-2">About</li>
            </ul>
          </div>

          <div className="col-md-5 offset-md-1 mb-3">
            <img className="LogoFotter" src={Logo} alt="" />
          </div>
        </div>

        <div className="d-flex flex-column flex-sm-row justify-content-between py-4  border-top">
          <p>&copy; 2023 Company, Inc. All rights reserved.</p>
          <ul className="list-unstyled d-flex">
            <li className="ms-3">
              <a className="link-body-emphasis" href="#">
                <svg
                  className="bi"
                  width="24"
                  height="24"
                  style={{ fill: "white" }}
                >
                  <use href="#twitter" />
                </svg>
              </a>
            </li>
            <li className="ms-3">
              <a
                className="link-body-emphasis"
                target="_blank"
                href="https://www.instagram.com/vishal_glass?igsh=b3hwOXdwZXZpdWNv"
              >
                <svg
                  className="bi"
                  width="24"
                  height="24"
                  style={{ fill: "white" }}
                >
                  <use href="#instagram" />
                </svg>
              </a>
            </li>
            <li className="ms-3">
              <a
                className="link-body-emphasis"
                target="_blank"
                href="https://www.justdial.com/Gandhidham/Vishal-Glass-Opposite-Gurudwara-Gate-Khanna-Market/9999P2836-2836-190119140016-M2H8_BZDET"
              >
                <svg
                  className="bi"
                  width="24"
                  height="24"
                  style={{ fill: "white" }}
                >
                  <use href="#facebook" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  );
}

export default MainFooter;
